import { T_SHIRT_SIZES } from './T_SHIRT_SIZES';
export var AVATAR_FONT_SIZES = Object.freeze({
  xs: T_SHIRT_SIZES.xs,
  sm: T_SHIRT_SIZES.sm,
  md: T_SHIRT_SIZES.md,
  lg: T_SHIRT_SIZES.lg,
  xl: T_SHIRT_SIZES.xl,
  xxl: T_SHIRT_SIZES.xxl
});